import { render, staticRenderFns } from "./endLink.vue?vue&type=template&id=bb5a53d8&scoped=true"
import script from "./endLink.vue?vue&type=script&lang=js"
export * from "./endLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5a53d8",
  null
  
)

export default component.exports